<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 物业APP轮播图 -->
    <PropertyBanner></PropertyBanner>
    <!-- 物业APP列表 -->
    <PropertyList></PropertyList>
    <!-- 物业移动 协同办公 -->
    <PropertyOffice></PropertyOffice>
    <!-- 移动综合管控 -->
    <PropertyControl></PropertyControl>
    <!-- 实时社区监管 -->
    <PropertySupervise></PropertySupervise>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/pc/components/TopNav.vue";
import ButtonNav from "../../../../components/pc/components/BottomNav.vue";
import PropertyBanner from '../../../../components/pc/Product/PropertyComponents/PropertyBanner.vue'
import PropertyList from '../../../../components/pc/Product/PropertyComponents/PropertyList.vue'
import PropertyOffice from '../../../../components/pc/Product/PropertyComponents/PropertyOffice.vue'
import PropertyControl from '../../../../components/pc/Product/PropertyComponents/PropertyControl.vue'
import PropertySupervise from '../../../../components/pc/Product/PropertyComponents/PropertySupervise.vue'

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
    PropertyBanner,
    PropertyList,
    PropertyOffice,
    PropertyControl,
    PropertySupervise
  },
};
</script>

<style scoped>
</style>
